export default {
  open: false,
  viewMode: "list"
};
